module.exports = __webpack_public_path__ + "static/media/34DSS2.6a5bf7fb.jpg";